import _ from "lodash";

export const flattenJSON = (data) => {
    const recurse = (obj, path) => {
      return _.flatMap(Object.entries(obj), ([key, value]) => {
        const newPath = [...path, key]; // Build the new path
        if (typeof value === "object" && value !== null) {
          return recurse(value, newPath); // Recursively handle nested objects
        }
        return { label: key, value: newPath.join(".") }; // Create { label, value } objects
      });
    };
    return recurse(data, []);
  };